import {populateGuestUserToken, populateGuestUser, populateEntityTypeLabelConfiguration} from '../api'

export const loadGuestUserToken = ({ state, commit }, {openId}) => {
  if (openId) {
    return populateGuestUserToken(openId).then((response) => {
      commit('LOAD_GUEST_USER_TOKEN', response)
      return response
    })
  }
}

export const loadGuestUser = ({ state, commit }, {token}) => {
  if (token) {
    return populateGuestUser(token).then((response) => {
      commit('LOAD_GUEST_USER', response)
      return response
    })
  }
}

export const loadEntityTypeLabelConfiguration = ({ state, commit }) => {
  return populateEntityTypeLabelConfiguration().then((response) => {
    commit('LOAD_ENTITY_TYPE_LABEL_CONFIGURATION', response)
    return response
  })
}



// WEBPACK FOOTER //
// ./src/app/guest/vuex/actions.js